import React, { Component } from "react";
import "./style.css";
class YearSelect extends Component {
  render() {
    const myDate = new Date();
    const year = myDate.getFullYear();
    const { visible, selectYear } = this.props;
    return (
      <div
        style={visible === false ? { display: "none" } : { display: "block" }}
        className="register_year_selelct"
      >
        <div
          onClick={() => this.props.handleCloseYearSelect()}
          className="year_select_shadow"
        ></div>
        <div className="year_selelct_box">
          <div
            onClick={() => {
              this.handleChangYear(year + 0);
            }}
            className={
              selectYear === year + 0 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 0}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 1);
            }}
            className={
              selectYear === year + 1 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 1}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 2);
            }}
            className={
              selectYear === year + 2 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 2}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 3);
            }}
            className={
              selectYear === year + 3 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 3}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 4);
            }}
            className={
              selectYear === year + 4 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 4}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 5);
            }}
            className={
              selectYear === year + 5 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 5}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 6);
            }}
            className={
              selectYear === year + 6 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 6}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 7);
            }}
            className={
              selectYear === year + 7 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 7}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 8);
            }}
            className={
              selectYear === year + 8 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 8}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 9);
            }}
            className={
              selectYear === year + 9 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 9}年高考
          </div>
          <div
            onClick={() => {
              this.handleChangYear(year + 10);
            }}
            className={
              selectYear === year + 10 + "年高考"
                ? "year_selelct_item_active"
                : "year_selelct_item"
            }
          >
            {year + 10}年高考
          </div>
        </div>
      </div>
    );
  }
  /**
   * 修改年份
   */
  handleChangYear = (year) => {
    this.props.handleChangYear(year + "年高考", false);
  };
}

export default YearSelect;



// WEBPACK FOOTER //
// ./src/containers/User/components/Register/components/YearSelect/index.js